import React, { useState } from "react";
import { Link } from "react-router-dom";
import '../styles/DiverSafety.css';

const DiverSafety = () => {
  const [activeIndex, setActiveIndex] = useState(null); // FIXED: Declare state

  const toggleQuestion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const questions = [
    {
      question: "As a Driver, how do I identify my rider?",
      answer:
        "On the ride screen, you will be able to see your rider’s name and profile picture. When you see your rider at the pickup location, please confirm their name and profile picture before proceeding.",
    },
    {
      question: "How do I rate a rider?",
      answer:
        "After each completed ride, you will have the option to rate the rider. Ratings help us provide a great experience for both riders and drivers.",
    },
  ];

  return (
    <>
     <div className="safety-page">
  <section className="safety-header">
    <h1>
      Berymo runs on safety to protect
      <br /> our community
    </h1>
  </section>
</div>


     <div class="diver-container">
  <h2>From pickup to dropoff,we are there for you</h2>
  <p class="diver-subtext">
    Berymo Driver app offers unmatched privacy and security  We want to ensure .<br />
   that our drivers feel as comfortable navigating through the map as the riders<br />
     feel riding in your car.
  </p>


        <div className="diver-grid">
          {[
            {
              img: "history",
              title: "Ride history",
              text: "All completed rides are recorded and saved in your Berymo Drivers app. Details of all rides are kept in your history for your own records",
            },
            {
              img: "3",
              title: "Top tier support",
              text: "Berymo provides top tier support whenever you need it. We are here to help when you need it most, at all times of the day",
            },
            {
              img: "headphone",
              title: "Emergency calling",
              text: "If you are involved in an emergency, tap the Emergency button found on your driver app or call 911.",
            },
            {
              img: "phone",
              title: "Call privacy",
              text: "When using the Berymo driver call function, we hide both you and your rider's phone number for privacy purposes.",
            },
            {
              img: "star",
              title: "Rider ratings",
              text: "We value your feedback. At the end of each completed ride, you will have the option to rate your rider.",
            },
            {
              img: "schedule",
              title: "On your Schedule",
              text: "Drive with Berymo and earn extra income wherever you are and whenever you want to drive. Earn on your own schedule without a boss.",
            },
          ].map((item, i) => (
            <div className="diver-box" key={i}>
              <img
                src={`/images/${item.img}.png`}
                alt={item.img}
                className="icon"
              />
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="divers-image">
        <img src="/images/driver-safety-general.jpg" alt="diver" />
      </div>

    {/* FAQ */}
      <div className="faq-sections">
        <h1>Frequently asked questions from our rider</h1>
        <div className="faq-lists">
          {questions.map((item, index) => (
  <div
    key={index}
    className="faq-items"
    onClick={() => toggleQuestion(index)}
  >
    <div className="faq-questions">
      <span>{item.question}</span>
      <span className="plus-icon">{activeIndex === index ? "×" : "+"}</span>
    </div>
    <div className={`faq-answers ${activeIndex === index ? 'open' : ''}`}>
      {item.answer}
    </div>
  </div>
))}

        </div>
      </div>
      <div className="limited-driver">
        <h1>Earn great money on your schedule</h1>
        <p>
          Drive with Berymo and earn up to $1,800 for the first 60 loops you
          complete in your city
        </p>
        <a href="https://apps.apple.com/us/app/berymo-driver/id1440035432">
       <button className="ridee">Sign Up To Drive</button>
       </a> 
      </div>
    </>
  );
};

export default DiverSafety;

